const pattern = /^[0-9BXZ][0-9A-Z]{9}$/

const ItemIdStringIsValid = (input = "") => {
    return pattern.test(input);
}

const MaxResultsIsValid = (hardwareSource = "", input = "") => {
    const inputNumber = Number(input);
    return hardwareSource !== "ALL" && Number.isSafeInteger(inputNumber) && inputNumber > 0;
}

export const inputValidation = {
    isItemIdValid: ItemIdStringIsValid,
    isMaxResultsValid: MaxResultsIsValid
}
